
import React, { useEffect, useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";
import API from "../api";

const COLORES = ["#2563eb", "#60a5fa", "#bfdbfe"];

const Dashboard = () => {
  const navigate = useNavigate();

  const [estadisticas, setEstadisticas] = useState({
    solicitudes_pendientes: 0,
    solicitudes_aprobadas: 0,
    viaticos_entregados: 0,
    liquidaciones_pendientes: 0
  });

  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const token = sessionStorage.getItem("token");

fetch(`${API}/estadisticas-viaticos`, {
  headers: {
    Authorization: `Bearer ${token}`
  }
})
      .then(async (res) => {
        if (!res.ok) {
          throw new Error("No se pudieron cargar las estadísticas");
        }
        return res.json();
      })
      .then((datos) => {
        setEstadisticas(datos);
      })
      .catch((err) => {
        console.error(err);
        setError(err.message);
      })
      .finally(() => {
        setCargando(false);
      });
  }, []);

  const cerrarSesion = () => {
    sessionStorage.removeItem("usuario");
    sessionStorage.removeItem("token");
    navigate("/");
  };

  const datosGrafica = [
    {
      name: "Pendientes",
      value: Number(estadisticas.solicitudes_pendientes)
    },
    {
      name: "Aprobadas",
      value: Number(estadisticas.solicitudes_aprobadas)
    },
    {
      name: "Entregadas",
      value: Number(estadisticas.viaticos_entregados)
    }
  ];

  const totalSolicitudes = datosGrafica.reduce(
    (total, item) => total + item.value,
    0
  );

  return (
    <div className="dashboard-container">

      {/* Barra superior */}
      <div className="top-bar">
        <span className="top-brand">
          Transportes Figueroa
        </span>

        <button
          className="top-button"
          onClick={() => navigate("/historial")}
        >
          Historial
        </button>

        <button
          className="top-button"
          onClick={() => navigate("/solicitudes-admin")}
        >
          Solicitudes
        </button>

        <button
          className="top-button"
          onClick={() => navigate("/liquidaciones-admin")}
        >
          Liquidaciones
        </button>

        {/* Nuevo botón */}
        <button
          className="top-button"
          onClick={() => navigate("/gestion-conductores")}
        >
          Gestión de conductores
        </button>     
<button
  className="top-button"
  onClick={() => navigate("/gestion-camiones")}
>
  Gestión de Camiones
</button>


        <button
          className="top-button logout-button"
          onClick={cerrarSesion}
        >
          Cerrar sesión
        </button>
      </div>

      {/* Encabezado */}
      <h1 className="dashboard-title">
        Panel de control
      </h1>

      <p className="dashboard-subtitle">
        Resumen general de solicitudes y liquidaciones de viáticos
      </p>

      {cargando && (
        <p className="dashboard-message">
          Cargando estadísticas...
        </p>
      )}

      {error && (
        <p className="dashboard-error">
          {error}
        </p>
      )}

      {!cargando && !error && (
        <>
          {/* Tarjetas de estadísticas */}
          <div className="cards-container">

            <div className="card">
              <p>Solicitudes pendientes</p>
              <h2>
                {estadisticas.solicitudes_pendientes}
              </h2>
            </div>

            <div className="card">
              <p>Solicitudes aprobadas</p>
              <h2>
                {estadisticas.solicitudes_aprobadas}
              </h2>
            </div>

            <div className="card">
              <p>Viáticos entregados</p>
              <h2>
                {estadisticas.viaticos_entregados}
              </h2>
            </div>

            <div className="card">
              <p>Liquidaciones pendientes</p>
              <h2>
                {estadisticas.liquidaciones_pendientes}
              </h2>
            </div>

          </div>

          {/* Gráfica */}
          <div className="chart-container">
            <h2>Estado de solicitudes</h2>

            {totalSolicitudes > 0 ? (
              <div
                style={{
                  width: "100%",
                  height: 320
                }}
              >
                <ResponsiveContainer
                  width="100%"
                  height="100%"
                >
                  <PieChart>
                    <Pie
                      data={datosGrafica}
                      cx="50%"
                      cy="50%"
                      innerRadius={65}
                      outerRadius={105}
                      dataKey="value"
                      nameKey="name"
                      label
                    >
                      {datosGrafica.map((item, index) => (
                        <Cell
                          key={item.name}
                          fill={COLORES[index]}
                        />
                      ))}
                    </Pie>

                    <Tooltip />
                    <Legend />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            ) : (
              <p>
                Aún no hay solicitudes registradas.
              </p>
            )}

            <p>
              <strong>Total de solicitudes:</strong>{" "}
              {totalSolicitudes}
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
